<template>
    <div class="warp">
        <list v-if="type == 1" @handleClick="handleClick" @bindShowDispose="showDispose"></list>  
        <three-d v-if="type == 2" :rowId="rowId" :pageTitle="pageTitle" @close="editClose" :tableData="tableData" @back="back"></three-d>
    </div>
</template>

<script>
let vm;
import List from "./List.vue";
import ThreeD from "./ThreeD.vue";
export default {
    components: { List,ThreeD},
    data() {
        return {
            type: 1,
            rowId: "",
            pageTitle: "",
            tableData:''
        };
    },
    created() {
        vm = this;
    },
    methods: {
        handleClick(row,data) {
            console.log(row)
            console.log(row.id)
            vm.tableData=data
            vm.bus.$emit("handleClick", row.id);
            vm.rowId = row.id;
            vm.pageTitle = row.name;
            vm.type = 2;
        },
        editClose() {
            vm.type = 1;
        },
        showDispose() {
            vm.type = 3;
        },
        back(type){
            console.log(type)
            vm.type = type
        }
    }
};
</script>

<style scoped>
.warp {
    width: 100%;height: 100%;box-sizing: border-box;
}
</style>

